import { mobRefreshTokenKey, tokenKey } from "../../app/constants/constants"
import { replacekeyLocalStorage } from "../../utils/localStorageUtils"

export const getTokenKey = () => {
  return replacekeyLocalStorage(tokenKey, mobRefreshTokenKey)
}

export const extractDeviceIdFromMobileLogin = (mobileLoginUrl: string | null) => {

  if (!mobileLoginUrl) {
    return null
  }

  const splitUrl = mobileLoginUrl.split('/')
  const mobileLoginIndex = splitUrl.findIndex(i => i === 'mobile-login')

  if (!mobileLoginIndex) {
    return null
  }

  const deviceId = splitUrl[mobileLoginIndex + 1]

  if (deviceId) {
    return deviceId
  }
  return null
}